export default "__VITE_ASSET__CjFItdXc__"